import Vue from 'vue'
import VueRouter from 'vue-router'
import Loading from '../views/Loading'
import store from '../store'

Vue.use(VueRouter)

const routes = [

  {
    path: '/loading',
    name: 'loading',
    component: Loading
  },

  {
    path: '/material',
    name: 'material',
    component: () => import('../views/material/Index'),
    children: [
      {
        path: 'edit',
        name: 'material.edit',
        component: () => import('../views/material/Edit'),
        props: (route) => ({
          material: store.getters['steps/stepState'].material,
          buttonLabel: route.params.action_label,
          isCopy: route.params.is_copy
        })
      },
      {
        path: 'select-type',
        name: 'material.select-type',
        component: () => import('../views/material/SelectType'),
        props: (route) => ({
          materialTypes: route.params.material_types,
          material: store.getters['steps/stepState'].material
        })
      },
      {
        path: 'select',
        name: 'material.select',
        component: () => import('../views/material/Select'),
        props: (route) => ({
          paginator: route.params.paginator,
          buttonLabel: route.params.button_label,
          headline: route.params.headline
        })
      }
    ]
  },

  {
    path: '/login/callback',
    name: 'login.callback',
    component: () => import('../views/Callback'),
    props: true
  },

  /**
   * Generic Message Page
   */
  {
    path: '/message',
    name: 'message',
    component: () => import('../views/Message'),
    props: (route) => ({
      headline: route.params.headline,
      message: route.params.message
    })
  },

  /**
   * Generic Links Page
   */
  {
    path: '/links',
    name: 'links',
    component: () => import('../views/Links'),
    props: (route) => ({
      headline: route.params.headline,
      message: route.params.message,
      links: route.params.links
    })
  },

  /**
   * Generic Error Page
   */
  {
    path: '/failed',
    name: 'failure',
    component: () => import('../views/Failure'),
    props: true
  },

  /**
   * Default Redirect to Failed Page
   */
  {
    path: '*',
    redirect: {
      name: 'loading'
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
